import { render, staticRenderFns } from "./FormRouteInsurance.vue?vue&type=template&id=2cdc0fc1&scoped=true&"
import script from "./FormRouteInsurance.vue?vue&type=script&lang=js&"
export * from "./FormRouteInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc0fc1",
  null
  
)

export default component.exports